const state = {
  recording: {
    selectedParticipants: [],
    transcriptData: [],
    participantsData: {},
    currentTime: 0,
    duration: 0,
    seekTime: null,
    videoElement: null,
  },
};

const getters = {
  recordingSelectedParticipants: (state) =>
    state.recording.selectedParticipants,
  recordingTranscriptData: (state) => state.recording.transcriptData,
  recordingParticipantsData: (state) => state.recording.participantsData,
  recordingCurrentTime: (state) => state.recording.currentTime,
  recordingDuration: (state) => state.recording.duration,
  recordingSeekTime: (state) => state.recording.seekTime,
  recordingVideoElement: (state) => state.recording.videoElement,
};

const mutations = {
  SET_RECORDING_SELECTED_PARTICIPANTS(state, participants) {
    state.recording.selectedParticipants = participants;
  },

  SET_RECORDING_TRANSCRIPT_DATA(state, { transcript, participants }) {
    state.recording.transcriptData = transcript || [];
    state.recording.participantsData = participants || {};
  },

  UPDATE_RECORDING_CURRENT_TIME(state, time) {
    state.recording.currentTime = time;
  },

  SET_RECORDING_DURATION(state, duration) {
    state.recording.duration = duration;
  },

  SET_RECORDING_SEEK_TIME(state, time) {
    state.recording.seekTime = time;
  },

  CLEAR_RECORDING_SEEK_TIME(state) {
    state.recording.seekTime = null;
  },

  SET_RECORDING_VIDEO_ELEMENT(state, element) {
    state.recording.videoElement = element;
  },

  RESET_RECORDING_STATE(state) {
    state.recording = {
      selectedParticipants: [],
      transcriptData: [],
      participantsData: {},
      currentTime: 0,
      duration: 0,
      seekTime: null,
      videoElement: null,
    };
  },
};

const actions = {
  setRecordingSelectedParticipants({ commit }, participants) {
    commit("SET_RECORDING_SELECTED_PARTICIPANTS", participants);
  },

  setRecordingTranscriptData({ commit }, data) {
    commit("SET_RECORDING_TRANSCRIPT_DATA", data);
  },

  updateRecordingCurrentTime({ commit }, time) {
    commit("UPDATE_RECORDING_CURRENT_TIME", time);
  },

  setRecordingDuration({ commit }, duration) {
    commit("SET_RECORDING_DURATION", duration);
  },

  seekRecordingToTime({ commit }, time) {
    commit("SET_RECORDING_SEEK_TIME", time);
  },

  clearRecordingSeekTime({ commit }) {
    commit("CLEAR_RECORDING_SEEK_TIME");
  },

  setRecordingVideoElement({ commit }, element) {
    commit("SET_RECORDING_VIDEO_ELEMENT", element);
  },

  resetRecordingState({ commit }) {
    commit("RESET_RECORDING_STATE");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
